module.exports = __webpack_public_path__ + "img/bg.f507db23.png";